import React from "react"

const Picture = ({path, title="", size}) => {
  return <img src={path} alt={title} style={{maxWidth:size}}/>
}

export default Picture;
